module.exports = __webpack_public_path__ + "img/titanium.be5030ca.webp";